import useEmblaCarousel from 'embla-carousel-react'
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useCallback } from 'react';
import { Link } from 'react-router-dom'

const COACHES = [
  {
    name: 'Triiibu Team',
    image: 'https://image.beholos.com/fit-in/400x400/img/fitness-pass-v2/life/personal-training/coaches/triibu.jpg',
    url: '/partners/triiibu-boutique-fitness',
    urlName: 'Triiibu MX',
  },
  {
    name: 'Maca Wellness',
    image: 'https://image.beholos.com/fit-in/400x400/img/fitness-pass-v2/life/personal-training/coaches/macawellness.jpg',
    url: '/partners/maca-wellness',
    urlName: 'Maca Wellness',
  },
  {
    name: 'Romina Derteano',
    image: 'https://image.beholos.com/fit-in/400x400/img/fitness-pass-v2/life/personal-training/coaches/romi.jpg',
    url: '/partners/stiletto-we-move',
    urlName: 'STILETTO WE MOVE',
  },
  {
    name: 'Gianluca Rossi',
    image: 'https://image.beholos.com/fit-in/400x400/img/fitness-pass-v2/life/personal-training/coaches/clubringo.jpg',
    url: '/partners/club-ringo',
    urlName: 'Club Ringo',
  },
  {
    name: 'Natali Aún Santiago',
    image: 'https://image.beholos.com/fit-in/400x400/img/fitness-pass-v2/life/personal-training/coaches/nati.jpg',
    url: '/partners/we-ballet-fitness',
    urlName: 'We Ballet Fitness',
  },
  {
    name: 'Harry Sterling',
    image: 'https://image.beholos.com/fit-in/400x400/img/fitness-pass-v2/life/personal-training/coaches/coachharry.jpg',
    url: '/partners/la-nacion',
    urlName: 'La Nación',
  },
  {
    name: 'Kiara Mayo y Gabriel Frischman',
    image: 'https://image.beholos.com/fit-in/400x400/img/fitness-pass-v2/life/personal-training/coaches/kiaramayo.jpg',
    url: '/partners/kiara-mayo-fit',
    urlName: 'Kiara Mayo',
  },
  {
    name: 'Mariana Matallana',
    image: 'https://image.beholos.com/fit-in/400x400/img/fitness-pass-v2/life/personal-training/coaches/mariana.jpg',
    url: '/partners/mariana-matallana',
    urlName: 'Mariana Matallana',
  },
  {
    name: 'Augusto Almeyra',
    image: 'https://image.beholos.com/fit-in/400x400/img/fitness-pass-v2/life/personal-training/coaches/augusto.jpg',
    url: '/partners/augusto-almeyra',
    urlName: 'Augusto Almeyra',
  },
  {
    name: 'R3leve Team',
    image: 'https://image.beholos.com/fit-in/400x400/img/fitness-pass-v2/life/personal-training/coaches/releveteam.jpg',
    url: '/partners/r3leve-barre-studio',
    urlName: 'R3leve Barre',
  },
  {
    name: 'Gabriela Cockburn',
    image: 'https://image.beholos.com/fit-in/400x400/img/fitness-pass-v2/life/personal-training/coaches/gaby.jpg',
    url: '/partners/yoga-desde-casa',
    urlName: 'Yoga desde casa',
  },
  {
    name: 'Augusto Alvarez Calderon',
    image: 'https://image.beholos.com/fit-in/400x400/img/fitness-pass-v2/life/personal-training/coaches/warrior.jpg',
    url: '/partners/the-warriors-mindset',
    urlName: 'Warrior Mindset',
  },
  {
    name: 'Melissa Berger',
    image: 'https://image.beholos.com/fit-in/400x400/img/fitness-pass-v2/life/personal-training/coaches/meli.jpg',
    url: '/partners/meli-berger-health-coach',
    urlName: 'Melissa Berger',
  },
  {
    name: 'Burn50 Team',
    image: 'https://image.beholos.com/fit-in/400x400/img/fitness-pass-v2/life/personal-training/coaches/burn50.jpg',
    url: '/partners/burn50',
    urlName: 'Burn50 Fitness Experience',
  },
  {
    name: 'Nicole Levaggi',
    image: 'https://image.beholos.com/fit-in/400x400/img/fitness-pass-v2/life/personal-training/coaches/fitguide.jpg',
    url: '/partners/the-fitguide',
    urlName: 'The Fitguide',
  },
]

export default function ProgramCoachesCarousel() {
  const [emblaRef, embla] = useEmblaCarousel({ loop: true, slidesToScroll: 5 })

  const scrollPrev = useCallback(() => embla?.scrollPrev(), [embla]);
  const scrollNext = useCallback(() => embla?.scrollNext(), [embla]);

  return (
    <div className="w-full mx-auto">
      <div className="flex items-center space-x-2">
        <button onClick={scrollPrev} className="px-2 py-1 shrink-0 cursor-pointer">
          <ChevronLeft size={40} className='text-holos-dark'/>
        </button>

        <div className="overflow-hidden flex-1" ref={emblaRef}>
          <div className="flex">
            {COACHES.map((coach, index) => (
              <div
                key={index}
                className="min-w-[20%] md:min-w-[20%] sm:min-w-[50%] flex flex-col items-center text-center px-2 py-6"
              >
                <div className="w-32 h-32 rounded-full overflow-hidden border">
                  <img
                    src={coach.image}
                    alt={coach.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <h6 className="font-semibold mt-4 text-md">{coach.name}</h6>
                <Link
                  to={coach.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-base text-holos-dark mt-1 hover:text-holos-dark/70"
                >
                  {coach.urlName} <span className="ml-1">›</span>
                </Link>
              </div>
            ))}
          </div>
        </div>
        <button onClick={scrollNext} className="px-2 py-1 shrink-0 cursor-pointer">
          <ChevronRight size={40} className='text-holos-dark'/>
        </button>
      </div>
    </div>
  )
}
